import { render, staticRenderFns } from "./SaleReportDimension.vue?vue&type=template&id=4c980e0e&scoped=true"
import script from "./SaleReportDimension.vue?vue&type=script&lang=js"
export * from "./SaleReportDimension.vue?vue&type=script&lang=js"
import style0 from "./SaleReportDimension.vue?vue&type=style&index=0&id=4c980e0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c980e0e",
  null
  
)

export default component.exports